export const numberAndCommaWithSpaceRegExp = /^[\d,\s]+$/;
